export function toKebabCase(str: string) {
  return str.replace(/_/g, "-");
}

export function toSnakeCase(str: string) {
  return str.replace(/-/g, "_");
}